import ModelUtil from '@leverege/model-util';
const TYPE = 'value.Thresholdizer';
function create(opts) {
  return {
    type: TYPE,
    value: 20
  };
}
function thresholdFor(model, obj, context) {
  return model.value;
}
export default {
  id: 'graphs.Thresholdizer.value',
  create,
  thresholdFor,
  name: 'Static Value',
  TYPE,
  ...ModelUtil.createAllValue('value')
};